import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'pdf-dark-theme',
  templateUrl: './pdf-dark-theme.component.html',
  styleUrls: ['./colors.css'],
  encapsulation: ViewEncapsulation.None,
})
export class PdfDarkThemeComponent {}
